import Swiper, { Navigation, Scrollbar, Mousewheel } from 'swiper';

const recommendedProducts = (
  ssRecommendationProfilesPriority,
  ssRecommendationProfilesSecondary,
  firstVariantSku,
  collectionId,
  offsetBeforeAfterMobile,
  offsetBeforeAfterDesktop
) => ({
  recommendationParamSetters: [],
  recommendedProducts: [],
  swiperInstance: null,

  get searchspringType() {
    return 'recommendations';
  },

  get searchspringRecommendationsTag() {
    return this.ssRecommendationProfiles;
  },

  async init() {
    this.cacheNodes();
    this.buildSwiper();
    var self = this;

    if (ssRecommendationProfilesPriority == 'no_priority') {
      ssRecommendationProfilesPriority = ssRecommendationProfilesSecondary;
    }

    this.ssRecommendationProfiles = ssRecommendationProfilesPriority;

    // UPDATE SLIDES whenever recommendedProducts changes
    this.$watch('recommendedProducts', () => {
      this.swiperInstance.update();
      this.swiperInstance.slideTo(0, 750);
    });
  },

  cacheNodes() {
    this.swiperEl = this.$refs.swiper;
  },

  buildSwiper() {
    if (!this.swiperEl) {
      return;
    }

    this.swiperInstance = new Swiper(this.swiperEl, {
      slidesPerView: 'auto',
      modules: [Navigation, Scrollbar, Mousewheel],
      scrollbar: {
        el: this.swiperEl.querySelector('.swiper-scrollbar'),
        hide: true,
      },
      navigation: {
        nextEl: this.swiperEl.querySelector('.swiper-button-next'),
        prevEl: this.swiperEl.querySelector('.swiper-button-prev'),
        disabledClass: 'swiper-button-hidden',
      },
      mousewheel: {
        forceToAxis: true,
      },
      spaceBetween: 16,
      slidesOffsetBefore: offsetBeforeAfterMobile,
      slidesOffsetAfter: offsetBeforeAfterMobile,
      breakpoints: {
        1024: {
          slidesOffsetBefore: offsetBeforeAfterDesktop,
          slidesOffsetAfter: offsetBeforeAfterDesktop,
        },
      },
    });
  },
});

export default recommendedProducts;
